let rows = window.rows;
window.collectionLogos = [];

if(document.getElementById('school-list')){
    const schoolList = document.getElementById('school-list');
    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i];
      window.collectionLogos[cells[4].split("?")[0].split("/")[cells[4].split("?")[0].split("/").length - 1]] = cells[5];
      if (cells.length > 0 && cells.some(cell => cell.trim() !== '')) {
        const school_href = cells[4].trim();
        const school_img_src = cells[5].trim();
        const schoolName = cells[0].trim();
        const listItem = document.createElement('li');
        const anchor1 = document.createElement('a');
        const schoolImage = document.createElement('span');
        const anchor2 = document.createElement('a');
        const conference = cells[2].trim();
        const conference2 = cells[3].trim();
        const state = cells[1].trim();
        const wrapper = document.createElement('div');
        wrapper.classList.add('find-your-school-list-item_wrapper');
        anchor1.setAttribute('href', school_href);
        schoolImage.classList.add('school-image');
        schoolImage.style.backgroundImage = `url(${school_img_src})`;
        anchor1.appendChild(schoolImage);
        // listItem.appendChild(anchor1);
        anchor2.setAttribute('href', school_href);
        anchor2.classList.add('school-list');
        anchor2.setAttribute('data-state', state);
        anchor2.setAttribute('data-conference', conference);
        anchor2.setAttribute('data-conference2', conference2);
        anchor2.textContent = schoolName;
        // listItem.appendChild(anchor2);
        wrapper.appendChild(anchor1);
        wrapper.appendChild(anchor2);
        listItem.appendChild(wrapper);
        listItem.setAttribute("data-sorting_value", schoolName)
        listItem.setAttribute("data-option-sequence", i)
        schoolList.appendChild(listItem);
      }
  }  
  const sortByState = document.getElementById('sort-by-state');
  const states = [];
  for (let i = 0; i < rows.length; i++) {
    const cells = rows[i];
    if (cells.length > 0) {
      const state = cells[1].trim();
      if (state !== '') {
        if (!states.includes(state)) {
          states.push(state);
        }
      }
    }
  }
  window.allStates = states.join(",").replace(" ", "_").toLowerCase();
  states.forEach(state => {
    const option = document.createElement('option');
    option.setAttribute('value', state);
    option.textContent = state;
    sortByState.appendChild(option);
  });
  const sortByConference = document.getElementById('sort-by-conference');
  const Conference = [];
  for (let i = 0; i < rows.length; i++) {
    const cells = rows[i];
    if (cells.length > 0) {
      const conference = cells[2].trim();
      const conference2 = cells[3].trim();
      if (conference !== '') {
        if (!Conference.includes(conference)) {
          Conference.push(conference);
        }
      }
      if (conference2 !== '' && conference2 !== '-') {
        if (!Conference.includes(conference2)) {
          Conference.push(conference2);
        }
      }
    }
  }
  Conference.forEach(conference => {
    const option = document.createElement('option');
    option.setAttribute('value', conference);
    option.textContent = conference;
    sortByConference.appendChild(option);
  });
  
  const filterInput = document.getElementById('filter-input');
  filterInput.addEventListener('input', () => {
    filterItems(filterInput.value);
  });
  const filterItems = (stateQuery, conferenceQuery, filterQuery) => {
    const items = schoolList.querySelectorAll('li');
    let allHidden = true;
    items.forEach(item => {
      const dataState = item.querySelector('.school-list').getAttribute('data-state');
      const dataConference = item.querySelector('.school-list').getAttribute('data-conference');
      const dataConference2 = item.querySelector('.school-list').getAttribute('data-conference2');
      const anchorText = item.querySelector('a:nth-child(2)').textContent.toLowerCase();
      // console.log("stateQuery", stateQuery, dataState, conferenceQuery, filterQuery)
      if (
        (stateQuery === '' || dataState === stateQuery) && (conferenceQuery === '' || dataConference === conferenceQuery || dataConference2 === conferenceQuery) && (filterQuery === '' || anchorText.startsWith(filterQuery.toLowerCase()))) {
        allHidden = false;
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
    if (allHidden) {
      document.querySelector('#error_message').style.display = 'block';
    } else {
      document.querySelector('#error_message').style.display = 'none';
    }
  };
  
  filterInput.addEventListener('input', () => {
    const selectedState = sortByState.value;
    const selectedConference = sortByConference.value;
    const filterQuery = filterInput.value.trim();
    filterItems(selectedState, selectedConference, filterQuery);
  });
  
  sortByState.addEventListener('change', (event) => {
    document.getElementById('sort-by-conference').selectedIndex = 0;
    const selectedState = event.target.value;
    const items = schoolList.querySelectorAll('li');
    items.forEach(item => {
      const dataState = item.querySelector('.school-list').getAttribute('data-state');
      if (dataState === selectedState) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
    const sortselectedState = document.getElementById('sort-by-state').value;
    const sortselectedConference = document.getElementById('sort-by-conference').value;
    const sortfilterQuery = document.getElementById('filter-input').value.trim();
    filterItems(sortselectedState, sortselectedConference, sortfilterQuery);
  });
  
  sortByConference.addEventListener('change', (event) => {
    document.getElementById('sort-by-state').selectedIndex = 0;
    const selectedConference = event.target.value;
    const items = schoolList.querySelectorAll('li');
    items.forEach(item => {
      const dataState = item.querySelector('.school-list').getAttribute('data-conference');
      if (dataState === selectedConference) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
    const conferenceselectedState = document.getElementById('sort-by-state').value;
    const conferenceselectedConference = document.getElementById('sort-by-conference').value;
    const conferencefilterQuery = document.getElementById('filter-input').value.trim();
    filterItems(conferenceselectedState, conferenceselectedConference, conferencefilterQuery);
  });
  
  var initFindschool = {
    init: function() {
      this.mainJS();
    },
    mainJS: function() {
      function insertAfter(el, html) {
        el.insertAdjacentHTML('afterend', html)
      }
      function insertBefore(el, html) {
        el.insertAdjacentHTML('beforebegin', html);
      }
      var conferenceConvertedString = {
        'Mountain West Conference': 'Mountain West',
        'Mid-American Conference': 'Mid-American',
        'Southeastern Conference': 'SEC',
        'Sun Belt Conference': 'Sun Belt',
        'American Athletic Conference': 'AAC',
        'Big 12 Conference': 'Big 12',
        'Missouri Valley Conference': 'Missouri Valley',
        'Atlantic Coast Conference': 'ACC',
        'Big East Conference': 'Big East',
        'Atlantic 10 Conference': 'A10',
        'Horizon League': 'Horizon',
        'Big Sky Conference': 'Big Sky',
        'Big Ten Conference': 'B1G',
        'Mid-American Conference': 'MAC'
      };
      var currentSortId = '';
      var selectedSortOption = '';
      const searchPopUp = document.querySelector("#searchPopUp");
      // insertAfter(document.querySelector('main#MainContent > div'), searchPopUp);
      document.querySelector('.searchPopUp input').addEventListener('input', (e) => {
        document.querySelector('input#filter-input').value = e.target.value;
        document.querySelector('input#filter-input').dispatchEvent(new Event('input', {
          bubbles: true
        }));
        setTimeout(() => {
          updateSuggestionList();
        }, 300);
      });
      document.querySelector('.search_section input').addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
          window.dataLayer.push({
            event: 'plp_search_school',
          });
          document.querySelector('.submitSearch').dispatchEvent(new Event('click', {
            bubbles: true
          }));
          event.preventDefault();
        }
      });

      function updateSuggestionList(params) {
        let list = '';
        if (document.querySelector('#find-your-school .find-your-school-list').innerHTML == '') {
          list = '<p class="loadSchools">Loading schools...</p>';
          (function schoolPollFor() {
            if (document.querySelector('#find-your-school .find-your-school-list').innerHTML !== '') {
              updateSuggestionList();
            } else if (document.readyState !== 'complete') {
              setTimeout(schoolPollFor, 25);
            }
          })();
        } else {
          list = document.
          querySelector('#find-your-school .find-your-school-list').innerHTML;
        }
        let error = document.querySelector('#find-your-school .error-message').outerHTML;
        document.querySelector('.suggestionList').innerHTML = `<ul>
                    ${list}
                </ul>
                ${error}
                `;
        document.querySelectorAll('.suggestionList li').forEach(element => {
          if (element.style.display !== 'none' && element.nextElementSibling && element.nextElementSibling.style.display == 'none') {
            element.classList.add('lastItem');
          }
        });
      }

      function showSearchPopup(params) {
        if (!document.querySelector('.searchPopUp.search_show')) {
          let inputTop = document.querySelector('.newFilterSect .searchInput').getBoundingClientRect().top - 10;
          document.querySelector('.input_area').style.top = `${inputTop}px`;
          document.querySelector('.searchPopUp').classList.add('search_show');
          document.body.style.overflow = 'hidden';
        }
        document.querySelector('.input_area input').focus();
      }

      function hideSearchPopup(params) {
        document.querySelector('.searchPopUp').classList.remove('search_show');
        document.body.style.overflow = 'auto';
      }
    
      function showSortByMethods(params) {
        document.querySelector('.sort-after-search').classList.add('search_show');
        // document.body.style.overflow = 'auto';
        document.querySelector(".mobileReturnBtn").style.display = "block";
      }

      function hideSortByMethods(params) {
        document.querySelector('.sort-after-search').classList.remove('search_show');
      }
      document.querySelector('.newFilterSect .searchInput').addEventListener('click', (e) => {
        document.querySelector('.find-your-school-list').classList.add('showAll');
        updateSuggestionList();
        showSearchPopup();
      });
      document.querySelector('.searchPopUp .closePopupIcon').addEventListener('click', () => {
        document.querySelector('.searchPopUp  .search_section input').value = '';
        document.querySelector('input#filter-input').value = '';
        document.querySelector('input#filter-input').dispatchEvent(new Event('input', {
          bubbles: true
        }));
        hideSearchPopup();
        document.querySelector('.find-your-school-list').classList.remove('showAll');
        resetSearch();
      });
      document.querySelector('.submitSearch').addEventListener('click', () => {
        let searchKey = document.querySelector('.searchPopUp input').value;
        hideSearchPopup();
        showSortByMethods();
        document.querySelector('.find-your-school-list').classList.remove('showAll');
        updateBreadcrumb('home', `Search results for "${searchKey}" (${ getVisibleItemCount() } ${ getVisibleItemCount() > 1 ? 'Schools' : 'School' })`);
        document.querySelector('.search_breadcrumb').classList.add('_show');
        document.querySelector('.filterOption').classList.add('_hide');
      });

      function getVisibleItemCount() {
        const schoolList = document.getElementById('school-list');
        const visibleItems = schoolList.querySelectorAll('li');
        let visibleCount = 0;
      
        visibleItems.forEach(item => {
          const itemStyle = window.getComputedStyle(item);
          if (itemStyle.display === 'block') {
            visibleCount++;
          }
          else if (itemStyle.display !== 'block' && itemStyle.display !== 'none') {
            visibleCount++;
          }
        });       
        return visibleCount;
      }
      
      const count = getVisibleItemCount();
      function showUpdateSortList(id) {
        let listHtml = '';
        var gId = id;
        
        if (document.querySelectorAll(`#${id} option`).length < 2) {
          // id == 'sort-by-state' ? 'Shop by State' : 'Shop by Conference'
          listHtml = `<p class="loadSchools">Loading ${id == 'sort-by-state' ? 'State' : 'Conference'}...</p>`;
          document.querySelector('.sortOptionList').innerHTML = `<ul>${listHtml}</ul>`;
          document.querySelector('.sortOptionList').classList.add("_show");
          (function sortPollFor() {
            if (document.querySelectorAll(`#${gId} option`).length > 1) {
              showUpdateSortList(id);
            } else if (document.readyState !== 'complete') {
              setTimeout(sortPollFor, 25);
            }
          })();
        } else {
          let allOptions = [];
          document.querySelectorAll(`#${id} option`).forEach((element, index) => {
            if (index !== 0) allOptions.push(element.value);
          });
          // console.log(allOptions);
          // console.log(allOptions.sort());
          allOptions = allOptions.sort();
          allOptions.forEach((element, index) => {
            listHtml = listHtml + `<li data-value="${element}">`
              if(id == "sort-by-state"){
                listHtml =listHtml + `<span class="state-icon"><img class="js-ajax-image" data-image_name="${element.replace(' ', '_')}" src="${window.location.origin + '/cdn/shop/files/' + element.replaceAll(' ','_') + '.svg' }"> </span> `;
              }
              listHtml = listHtml + `<span class="state-text">${conferenceConvertedString[element] ?
                            conferenceConvertedString[element] : element}</span></li>`;
          });
          document.querySelector('.sortOptionList').innerHTML = `<ul class="${ (id == "sort-by-state") ? 'state-list' : '' }">${listHtml}</ul>`;
          document.querySelector('.sortOptionList').classList.add("_show");
          document.querySelectorAll('.sortOptionList li').forEach(element => {
            element.addEventListener('click', (e) => {
              
              if(id == "sort-by-state"){
                document.querySelectorAll(".return-text").forEach(el => {
                  el.innerHTML = "Return to Shop By State";
                })
              }
              else if(id == "sort-by-conference"){
                 document.querySelectorAll(".return-text").forEach(el => {
                  el.innerHTML = "Return to Shop by Conference";
                })
              }
              else{
                 document.querySelectorAll(".return-text").forEach(el => {
                  el.innerHTML = "Return";
                })
              }

              // document.querySelectorAll(".sort_by").forEach(el => {
              //   el.classList.remove("active");
              // })
              // document.querySelector(".sort_by").classList.add("active");
              
              selectedSortOption = e.currentTarget.dataset.value;
              document.querySelector(`#${id}`).value = e.currentTarget.dataset.value;
              document.querySelector(`#${id}`).dispatchEvent(new Event('change', {
                bubbles: true
              }));
              window.currentStateImage = (typeof e.currentTarget.querySelector(".state-icon img") !== "undefined" ) ? (e.currentTarget.querySelector(".state-icon img")) ? e.currentTarget.querySelector(".state-icon img").src : "" : "";
              document.querySelector('.sortOptionList').classList.remove('_show');
              document.querySelector('.find-your-school-list').classList.remove('_hide');
              document.querySelector('.find-your-school-list').classList.remove('showAll');
              updateBreadcrumb('sortOptionList', selectedSortOption);
              window.dataLayer.push({
                event: currentSortId,
                currentSortId: currentSortId == 'sort-by-state' ? 'shop by state' : 'shop by conference',
                selectedSortOption: selectedSortOption.toLowerCase(),
                sortEvent: currentSortId == 'sort-by-state' ? 'plp_shop_by_state' : 'plp_shop_by_conference',
              });
              showSortByMethods();
            });
          });
        }
      }
      
      function updateBreadcrumb(prevState, text) {
        document.querySelector('.backButton').dataset.backto = prevState;
        document.querySelector('.breadcrumbTxt').innerHTML = text;
        if(text == "Shop by Conference"){
          document.querySelector(".school-list-wrapper").classList.add("no-svg-image")
        }
        else{
          document.querySelector(".school-list-wrapper").classList.remove("no-svg-image")
        }
        imageUrlToSvg(window.currentStateImage);
      }

      function resetSearch(params) {
        
        document.querySelector('input#filter-input').value = '';
        document.querySelector('input#filter-input').dispatchEvent(new Event('input', {
          bubbles: true
        }));

        document.querySelector(".searchPopUp input").value = "";
        document.querySelector(".searchPopUp input").dispatchEvent(new Event('input', {
          bubbles: true
        }));

        document.querySelectorAll(".searchPopUp .suggestionList li").forEach(el => {              
          el.style.display = "block";
        })
      }

      function resetSort(params) {
        document.querySelector(`#sort-by-state`).value = '';
        document.querySelector(`#sort-by-conference`).value = '';
        document.querySelector(`#sort-by-state`).dispatchEvent(new Event('change', {
          bubbles: true
        }));
        document.querySelector(`#sort-by-conference`).dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
      
      document.querySelector('.backButton').addEventListener('click', (e) => {
        let backto = e.currentTarget.dataset.backto;
        if (backto == 'home') {
          document.querySelector('.search_breadcrumb').classList.remove('_show');
          document.querySelector('.sortOptionList').classList.remove('_show');
          document.querySelector('.filterOption ').classList.remove('_hide');
          document.querySelector('.find-your-school-list').classList.remove('_hide');
          document.querySelector('.find-your-school-list').classList.add('showAll');
          document.querySelector('.mobileReturnBtn').classList.remove('_show');
          resetSearch();
          // resetSort();
          sortItems("popular");
          hideSortByMethods()
          document.querySelector(".mobileReturnBtn").style.display = "none";

          document.querySelector(`#sort-by-state`).value = "";
          document.querySelector(`#sort-by-state`).dispatchEvent(new Event('change', {
            bubbles: true
          }));
          document.querySelectorAll(".searchPopUp .suggestionList li").forEach(el => {
              el.style.display = "block";
          })
        } 
        else if (backto == 'sortOptionList') {
          document.querySelector('.search_breadcrumb').classList.add('_show');
          document.querySelector('.sortOptionList').classList.add('_show');
          document.querySelector('.filterOption ').classList.add('_hide');
          document.querySelector('.find-your-school-list').classList.add('_hide');
          let breadcrumbTxt = currentSortId == 'sort-by-state' ? 'Shop by State' : 'Shop by Conference';
          document.querySelector('.breadcrumbTxt').innerText = breadcrumbTxt;
          document.querySelector('.backButton').dataset.backto = 'home';
          hideSortByMethods()
          document.querySelector(".mobileReturnBtn").style.display = "block";
          document.querySelector(".mobileReturnBtn .return-text").innerHTML = "Return";
          document.querySelectorAll(".return-text").forEach(el => {
            el.innerHTML = "Return";
          })
          document.querySelector(`#sort-by-state`).value = "";
          document.querySelector(`#sort-by-state`).dispatchEvent(new Event('change', {
            bubbles: true
          }));
          document.querySelectorAll(".searchPopUp .suggestionList li").forEach(el => {
            el.style.display = "block";
          })
        }
      });
      
      document.querySelectorAll('.sortSect button').forEach(element => {
        element.addEventListener('click', (e) => {
          document.querySelector('.filterOption').classList.add('_hide');
          document.querySelector('.search_breadcrumb').classList.add('_show');
          document.querySelector('#find-your-school .find-your-school-list').classList.add('_hide');
          document.querySelector('.mobileReturnBtn').classList.add('_show');
          // document.querySelector('.backButton').dataset.backto = 'home';
          let id = e.target.dataset.id;
          currentSortId = id;
          updateBreadcrumb('home', id == 'sort-by-state' ? 'Shop by State' : 'Shop by Conference');
          showUpdateSortList(id);
          document.querySelector(".mobileReturnBtn").style.display = "block";
        });
      });
      
      document.querySelector('button.mobileReturnBtn').addEventListener('click', (e) => {
        document.querySelector('.search_breadcrumb .backButton').click();
      });
      document.body.addEventListener('click', (e) => {
        if (e.target.closest('.searchPopUp') && !e.target.closest('.input_area')) {
          hideSearchPopup();
        }
      })
      function sortItems(method) {
        const itemsContainer = document.querySelector("#school-list");
        const items = Array.from(itemsContainer.querySelectorAll("li"));
        
        switch (method) {
          case 'popular':
            items.sort((a, b) => {
              const aSequence = parseInt(a.getAttribute("data-option-sequence"), 10);
              const bSequence = parseInt(b.getAttribute("data-option-sequence"), 10);
              return aSequence - bSequence;
            });
            break;
        
          case 'a-z':
            items.sort((a, b) => {
              const aValue = a.getAttribute("data-sorting_value").toLowerCase();
              const bValue = b.getAttribute("data-sorting_value").toLowerCase();
              return aValue.localeCompare(bValue);
            });
            break;
        
          case 'z-a':
            items.sort((a, b) => {
              const aValue = a.getAttribute("data-sorting_value").toLowerCase();
              const bValue = b.getAttribute("data-sorting_value").toLowerCase();
              return bValue.localeCompare(aValue);
            });
            break;
        
          case 'newly-added':
            items.sort((a, b) => {
              const aSequence = parseInt(a.getAttribute("data-option-sequence"), 10);
              const bSequence = parseInt(b.getAttribute("data-option-sequence"), 10);
              return bSequence - aSequence;
            });
            break;
        
          default:
            console.error('Unknown sorting method:', method);
            return;
        }
        itemsContainer.innerHTML = '';
        items.forEach(item => {
          itemsContainer.appendChild(item);
        });
      }

      function imageUrlToSvg(imgURl){
        if(imgURl != ""){
          const svgUrl = imgURl;
          fetch(svgUrl)
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.text();
            })
            .then(svgContent => {
              // Create a div to hold the SVG
              const div = document.createElement('div');
              div.innerHTML = svgContent;
              document.querySelector(".school-list-wrapper .breadcrumbTxt").innerHTML = svgContent+ document.querySelector(".school-list-wrapper .breadcrumbTxt").innerHTML;
              window.currentStateImage = "";
            })
            .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
            });
          }
        }
      
      document.querySelectorAll(".sort_by").forEach(sortButton => {
      sortButton.addEventListener("click", function (e) {
        e.currentTarget.parentNode.querySelectorAll(".sort_by").forEach(el => {
          el.classList.remove("active");
        })
        e.currentTarget.classList.add("active");
        const method = sortButton.dataset.sort_by;
        sortItems(method);
        document.querySelector(".sorting-techniques").classList.toggle("open");
      });
      });
    }
  };
  (function findYourschool() {
    if (document.querySelector('main#MainContent > div') && document.querySelector('.sort_options')) {
      initFindschool.init();
    } else if (document.readyState !== 'complete') {
      console.log("poling..")
      setTimeout(findYourschool, 25);
    }
  })();
}
else{
  for (let i = 0; i < rows.length; i++) {
    const cells = rows[i];
    window.collectionLogos[cells[4].split("?")[0].split("/")[cells[4].split("?")[0].split("/").length - 1]] = cells[5];
  }
}



// fetch('https://docs.google.com/spreadsheets/d/1w6Sgr5ehcD8JZ7mdrm9oOAhjYhgkgjGCsJoPO1MO_fA/export?format=csv').then(response => response.text()).then(data => {
//   const rows = data.split('\n').map(row => row.split(','));
//   console.log('rows', rows);
//   window.collectionLogos = [];
  
//   if(document.getElementById('school-list')){
//       const schoolList = document.getElementById('school-list');
//       for (let i = 1; i < rows.length; i++) {
//         const cells = rows[i];
//         window.collectionLogos[cells[4].split("?")[0].split("/")[cells[4].split("?")[0].split("/").length - 1]] = cells[5];
//         if (cells.length > 0 && cells.some(cell => cell.trim() !== '')) {
//           const school_href = cells[4].trim();
//           const school_img_src = cells[5].trim();
//           const schoolName = cells[0].trim();
//           const listItem = document.createElement('li');
//           const anchor1 = document.createElement('a');
//           const schoolImage = document.createElement('span');
//           const anchor2 = document.createElement('a');
//           const conference = cells[2].trim();
//           const conference2 = cells[3].trim();
//           const state = cells[1].trim();
//           const wrapper = document.createElement('div');
//           wrapper.classList.add('find-your-school-list-item_wrapper');
//           anchor1.setAttribute('href', school_href);
//           schoolImage.classList.add('school-image');
//           schoolImage.style.backgroundImage = `url(${school_img_src})`;
//           anchor1.appendChild(schoolImage);
//           // listItem.appendChild(anchor1);
//           anchor2.setAttribute('href', school_href);
//           anchor2.classList.add('school-list');
//           anchor2.setAttribute('data-state', state);
//           anchor2.setAttribute('data-conference', conference);
//           anchor2.setAttribute('data-conference2', conference2);
//           anchor2.textContent = schoolName;
//           // listItem.appendChild(anchor2);
//           wrapper.appendChild(anchor1);
//           wrapper.appendChild(anchor2);
//           listItem.appendChild(wrapper);
//           listItem.setAttribute("data-sorting_value", schoolName)
//           listItem.setAttribute("data-option-sequence", i)
//           schoolList.appendChild(listItem);
//         }
//     }  
//     const sortByState = document.getElementById('sort-by-state');
//     const states = [];
//     for (let i = 1; i < rows.length; i++) {
//       const cells = rows[i];
//       if (cells.length > 0) {
//         const state = cells[1].trim();
//         if (state !== '') {
//           if (!states.includes(state)) {
//             states.push(state);
//           }
//         }
//       }
//     }
//     window.allStates = states.join(",").replace(" ", "_").toLowerCase();
//     states.forEach(state => {
//       const option = document.createElement('option');
//       option.setAttribute('value', state);
//       option.textContent = state;
//       sortByState.appendChild(option);
//     });
//     const sortByConference = document.getElementById('sort-by-conference');
//     const Conference = [];
//     for (let i = 1; i < rows.length; i++) {
//       const cells = rows[i];
//       if (cells.length > 0) {
//         const conference = cells[2].trim();
//         const conference2 = cells[3].trim();
//         if (conference !== '') {
//           if (!Conference.includes(conference)) {
//             Conference.push(conference);
//           }
//         }
//         if (conference2 !== '' && conference2 !== '-') {
//           if (!Conference.includes(conference2)) {
//             Conference.push(conference2);
//           }
//         }
//       }
//     }
//     Conference.forEach(conference => {
//       const option = document.createElement('option');
//       option.setAttribute('value', conference);
//       option.textContent = conference;
//       sortByConference.appendChild(option);
//     });
    
//     const filterInput = document.getElementById('filter-input');
//     filterInput.addEventListener('input', () => {
//       filterItems(filterInput.value);
//     });
//     const filterItems = (stateQuery, conferenceQuery, filterQuery) => {
//       const items = schoolList.querySelectorAll('li');
//       let allHidden = true;
//       items.forEach(item => {
//         const dataState = item.querySelector('.school-list').getAttribute('data-state');
//         const dataConference = item.querySelector('.school-list').getAttribute('data-conference');
//         const dataConference2 = item.querySelector('.school-list').getAttribute('data-conference2');
//         const anchorText = item.querySelector('a:nth-child(2)').textContent.toLowerCase();
//         // console.log("stateQuery", stateQuery, dataState, conferenceQuery, filterQuery)
//         if (
//           (stateQuery === '' || dataState === stateQuery) && (conferenceQuery === '' || dataConference === conferenceQuery || dataConference2 === conferenceQuery) && (filterQuery === '' || anchorText.startsWith(filterQuery.toLowerCase()))) {
//           allHidden = false;
//           item.style.display = 'block';
//         } else {
//           item.style.display = 'none';
//         }
//       });
//       if (allHidden) {
//         document.querySelector('#error_message').style.display = 'block';
//       } else {
//         document.querySelector('#error_message').style.display = 'none';
//       }
//     };
    
//     filterInput.addEventListener('input', () => {
//       const selectedState = sortByState.value;
//       const selectedConference = sortByConference.value;
//       const filterQuery = filterInput.value.trim();
//       filterItems(selectedState, selectedConference, filterQuery);
//     });
    
//     sortByState.addEventListener('change', (event) => {
//       document.getElementById('sort-by-conference').selectedIndex = 0;
//       const selectedState = event.target.value;
//       const items = schoolList.querySelectorAll('li');
//       items.forEach(item => {
//         const dataState = item.querySelector('.school-list').getAttribute('data-state');
//         if (dataState === selectedState) {
//           item.style.display = 'block';
//         } else {
//           item.style.display = 'none';
//         }
//       });
//       const sortselectedState = document.getElementById('sort-by-state').value;
//       const sortselectedConference = document.getElementById('sort-by-conference').value;
//       const sortfilterQuery = document.getElementById('filter-input').value.trim();
//       filterItems(sortselectedState, sortselectedConference, sortfilterQuery);
//     });
    
//     sortByConference.addEventListener('change', (event) => {
//       document.getElementById('sort-by-state').selectedIndex = 0;
//       const selectedConference = event.target.value;
//       const items = schoolList.querySelectorAll('li');
//       items.forEach(item => {
//         const dataState = item.querySelector('.school-list').getAttribute('data-conference');
//         if (dataState === selectedConference) {
//           item.style.display = 'block';
//         } else {
//           item.style.display = 'none';
//         }
//       });
//       const conferenceselectedState = document.getElementById('sort-by-state').value;
//       const conferenceselectedConference = document.getElementById('sort-by-conference').value;
//       const conferencefilterQuery = document.getElementById('filter-input').value.trim();
//       filterItems(conferenceselectedState, conferenceselectedConference, conferencefilterQuery);
//     });
    
//     var initFindschool = {
//       init: function() {
//         this.mainJS();
//       },
//       mainJS: function() {
//         function insertAfter(el, html) {
//           el.insertAdjacentHTML('afterend', html)
//         }
//         function insertBefore(el, html) {
//           el.insertAdjacentHTML('beforebegin', html);
//         }
//         var conferenceConvertedString = {
//           'Mountain West Conference': 'Mountain West',
//           'Mid-American Conference': 'Mid-American',
//           'Southeastern Conference': 'SEC',
//           'Sun Belt Conference': 'Sun Belt',
//           'American Athletic Conference': 'AAC',
//           'Big 12 Conference': 'Big 12',
//           'Missouri Valley Conference': 'Missouri Valley',
//           'Atlantic Coast Conference': 'ACC',
//           'Big East Conference': 'Big East',
//           'Atlantic 10 Conference': 'A10',
//           'Horizon League': 'Horizon',
//           'Big Sky Conference': 'Big Sky',
//           'Big Ten Conference': 'B1G',
//           'Mid-American Conference': 'MAC'
//         };
//         var currentSortId = '';
//         var selectedSortOption = '';
//         const searchPopUp = document.querySelector("#searchPopUp");
//         // insertAfter(document.querySelector('main#MainContent > div'), searchPopUp);
//         document.querySelector('.searchPopUp input').addEventListener('input', (e) => {
//           document.querySelector('input#filter-input').value = e.target.value;
//           document.querySelector('input#filter-input').dispatchEvent(new Event('input', {
//             bubbles: true
//           }));
//           setTimeout(() => {
//             updateSuggestionList();
//           }, 300);
//         });
//         document.querySelector('.search_section input').addEventListener("keypress", function(event) {
//           if (event.key === "Enter") {
//             window.dataLayer.push({
//               event: 'plp_search_school',
//             });
//             document.querySelector('.submitSearch').dispatchEvent(new Event('click', {
//               bubbles: true
//             }));
//             event.preventDefault();
//           }
//         });
  
//         function updateSuggestionList(params) {
//           let list = '';
//           if (document.querySelector('#find-your-school .find-your-school-list').innerHTML == '') {
//             list = '<p class="loadSchools">Loading schools...</p>';
//             (function schoolPollFor() {
//               if (document.querySelector('#find-your-school .find-your-school-list').innerHTML !== '') {
//                 updateSuggestionList();
//               } else if (document.readyState !== 'complete') {
//                 setTimeout(schoolPollFor, 25);
//               }
//             })();
//           } else {
//             list = document.
//             querySelector('#find-your-school .find-your-school-list').innerHTML;
//           }
//           let error = document.querySelector('#find-your-school .error-message').outerHTML;
//           document.querySelector('.suggestionList').innerHTML = `<ul>
//                       ${list}
//                   </ul>
//                   ${error}
//                   `;
//           document.querySelectorAll('.suggestionList li').forEach(element => {
//             if (element.style.display !== 'none' && element.nextElementSibling && element.nextElementSibling.style.display == 'none') {
//               element.classList.add('lastItem');
//             }
//           });
//         }
  
//         function showSearchPopup(params) {
//           if (!document.querySelector('.searchPopUp.search_show')) {
//             let inputTop = document.querySelector('.newFilterSect .searchInput').getBoundingClientRect().top - 10;
//             document.querySelector('.input_area').style.top = `${inputTop}px`;
//             document.querySelector('.searchPopUp').classList.add('search_show');
//             document.body.style.overflow = 'hidden';
//           }
//           document.querySelector('.input_area input').focus();
//         }
  
//         function hideSearchPopup(params) {
//           document.querySelector('.searchPopUp').classList.remove('search_show');
//           document.body.style.overflow = 'auto';
//         }
      
//         function showSortByMethods(params) {
//           document.querySelector('.sort-after-search').classList.add('search_show');
//           // document.body.style.overflow = 'auto';
//           document.querySelector(".mobileReturnBtn").style.display = "block";
//         }
  
//         function hideSortByMethods(params) {
//           document.querySelector('.sort-after-search').classList.remove('search_show');
//         }
//         document.querySelector('.newFilterSect .searchInput').addEventListener('click', (e) => {
//           document.querySelector('.find-your-school-list').classList.add('showAll');
//           updateSuggestionList();
//           showSearchPopup();
//         });
//         document.querySelector('.searchPopUp .closePopupIcon').addEventListener('click', () => {
//           document.querySelector('.searchPopUp  .search_section input').value = '';
//           document.querySelector('input#filter-input').value = '';
//           document.querySelector('input#filter-input').dispatchEvent(new Event('input', {
//             bubbles: true
//           }));
//           hideSearchPopup();
//           document.querySelector('.find-your-school-list').classList.remove('showAll');
//           resetSearch();
//         });
//         document.querySelector('.submitSearch').addEventListener('click', () => {
//           let searchKey = document.querySelector('.searchPopUp input').value;
//           hideSearchPopup();
//           showSortByMethods();
//           document.querySelector('.find-your-school-list').classList.remove('showAll');
//           updateBreadcrumb('home', `Search results for "${searchKey}" (${ getVisibleItemCount() } ${ getVisibleItemCount() > 1 ? 'Schools' : 'School' })`);
//           document.querySelector('.search_breadcrumb').classList.add('_show');
//           document.querySelector('.filterOption').classList.add('_hide');
//         });
  
//         function getVisibleItemCount() {
//           const schoolList = document.getElementById('school-list');
//           const visibleItems = schoolList.querySelectorAll('li');
//           let visibleCount = 0;
        
//           visibleItems.forEach(item => {
//             const itemStyle = window.getComputedStyle(item);
//             if (itemStyle.display === 'block') {
//               visibleCount++;
//             }
//             else if (itemStyle.display !== 'block' && itemStyle.display !== 'none') {
//               visibleCount++;
//             }
//           });       
//           return visibleCount;
//         }
        
//         const count = getVisibleItemCount();
//         function showUpdateSortList(id) {
//           let listHtml = '';
//           var gId = id;
          
//           if (document.querySelectorAll(`#${id} option`).length < 2) {
//             // id == 'sort-by-state' ? 'Shop by State' : 'Shop by Conference'
//             listHtml = `<p class="loadSchools">Loading ${id == 'sort-by-state' ? 'State' : 'Conference'}...</p>`;
//             document.querySelector('.sortOptionList').innerHTML = `<ul>${listHtml}</ul>`;
//             document.querySelector('.sortOptionList').classList.add("_show");
//             (function sortPollFor() {
//               if (document.querySelectorAll(`#${gId} option`).length > 1) {
//                 showUpdateSortList(id);
//               } else if (document.readyState !== 'complete') {
//                 setTimeout(sortPollFor, 25);
//               }
//             })();
//           } else {
//             let allOptions = [];
//             document.querySelectorAll(`#${id} option`).forEach((element, index) => {
//               if (index !== 0) allOptions.push(element.value);
//             });
//             // console.log(allOptions);
//             // console.log(allOptions.sort());
//             allOptions = allOptions.sort();
//             allOptions.forEach((element, index) => {
//               listHtml = listHtml + `<li data-value="${element}">`
//                 if(id == "sort-by-state"){
//                   listHtml =listHtml + `<span class="state-icon"><img class="js-ajax-image" data-image_name="${element.replace(' ', '_')}" src="${window.location.origin + '/cdn/shop/files/' + element.replaceAll(' ','_') + '.svg' }"> </span> `;
//                 }
//                 listHtml = listHtml + `<span class="state-text">${conferenceConvertedString[element] ?
//                               conferenceConvertedString[element] : element}</span></li>`;
//             });
//             document.querySelector('.sortOptionList').innerHTML = `<ul class="${ (id == "sort-by-state") ? 'state-list' : '' }">${listHtml}</ul>`;
//             document.querySelector('.sortOptionList').classList.add("_show");
//             document.querySelectorAll('.sortOptionList li').forEach(element => {
//               element.addEventListener('click', (e) => {
                
//                 if(id == "sort-by-state"){
//                   document.querySelectorAll(".return-text").forEach(el => {
//                     el.innerHTML = "Return to Shop By State";
//                   })
//                 }
//                 else if(id == "sort-by-conference"){
//                    document.querySelectorAll(".return-text").forEach(el => {
//                     el.innerHTML = "Return to Shop by Conference";
//                   })
//                 }
//                 else{
//                    document.querySelectorAll(".return-text").forEach(el => {
//                     el.innerHTML = "Return";
//                   })
//                 }
  
//                 // document.querySelectorAll(".sort_by").forEach(el => {
//                 //   el.classList.remove("active");
//                 // })
//                 // document.querySelector(".sort_by").classList.add("active");
                
//                 selectedSortOption = e.currentTarget.dataset.value;
//                 document.querySelector(`#${id}`).value = e.currentTarget.dataset.value;
//                 document.querySelector(`#${id}`).dispatchEvent(new Event('change', {
//                   bubbles: true
//                 }));
//                 window.currentStateImage = (typeof e.currentTarget.querySelector(".state-icon img") !== "undefined" ) ? (e.currentTarget.querySelector(".state-icon img")) ? e.currentTarget.querySelector(".state-icon img").src : "" : "";
//                 document.querySelector('.sortOptionList').classList.remove('_show');
//                 document.querySelector('.find-your-school-list').classList.remove('_hide');
//                 document.querySelector('.find-your-school-list').classList.remove('showAll');
//                 updateBreadcrumb('sortOptionList', selectedSortOption);
//                 window.dataLayer.push({
//                   event: currentSortId,
//                   currentSortId: currentSortId == 'sort-by-state' ? 'shop by state' : 'shop by conference',
//                   selectedSortOption: selectedSortOption.toLowerCase(),
//                   sortEvent: currentSortId == 'sort-by-state' ? 'plp_shop_by_state' : 'plp_shop_by_conference',
//                 });
//                 showSortByMethods();
//               });
//             });
//           }
//         }
        
//         function updateBreadcrumb(prevState, text) {
//           document.querySelector('.backButton').dataset.backto = prevState;
//           document.querySelector('.breadcrumbTxt').innerHTML = text;
//           if(text == "Shop by Conference"){
//             document.querySelector(".school-list-wrapper").classList.add("no-svg-image")
//           }
//           else{
//             document.querySelector(".school-list-wrapper").classList.remove("no-svg-image")
//           }
//           imageUrlToSvg(window.currentStateImage);
//         }
  
//         function resetSearch(params) {
          
//           document.querySelector('input#filter-input').value = '';
//           document.querySelector('input#filter-input').dispatchEvent(new Event('input', {
//             bubbles: true
//           }));
  
//           document.querySelector(".searchPopUp input").value = "";
//           document.querySelector(".searchPopUp input").dispatchEvent(new Event('input', {
//             bubbles: true
//           }));
  
//           document.querySelectorAll(".searchPopUp .suggestionList li").forEach(el => {              
//             el.style.display = "block";
//           })
//         }
  
//         function resetSort(params) {
//           document.querySelector(`#sort-by-state`).value = '';
//           document.querySelector(`#sort-by-conference`).value = '';
//           document.querySelector(`#sort-by-state`).dispatchEvent(new Event('change', {
//             bubbles: true
//           }));
//           document.querySelector(`#sort-by-conference`).dispatchEvent(new Event('change', {
//             bubbles: true
//           }));
//         }
        
//         document.querySelector('.backButton').addEventListener('click', (e) => {
//           let backto = e.currentTarget.dataset.backto;
//           if (backto == 'home') {
//             document.querySelector('.search_breadcrumb').classList.remove('_show');
//             document.querySelector('.sortOptionList').classList.remove('_show');
//             document.querySelector('.filterOption ').classList.remove('_hide');
//             document.querySelector('.find-your-school-list').classList.remove('_hide');
//             document.querySelector('.find-your-school-list').classList.add('showAll');
//             document.querySelector('.mobileReturnBtn').classList.remove('_show');
//             resetSearch();
//             // resetSort();
//             sortItems("popular");
//             hideSortByMethods()
//             document.querySelector(".mobileReturnBtn").style.display = "none";
  
//             document.querySelector(`#sort-by-state`).value = "";
//             document.querySelector(`#sort-by-state`).dispatchEvent(new Event('change', {
//               bubbles: true
//             }));
//             document.querySelectorAll(".searchPopUp .suggestionList li").forEach(el => {
//                 el.style.display = "block";
//             })
//           } 
//           else if (backto == 'sortOptionList') {
//             document.querySelector('.search_breadcrumb').classList.add('_show');
//             document.querySelector('.sortOptionList').classList.add('_show');
//             document.querySelector('.filterOption ').classList.add('_hide');
//             document.querySelector('.find-your-school-list').classList.add('_hide');
//             let breadcrumbTxt = currentSortId == 'sort-by-state' ? 'Shop by State' : 'Shop by Conference';
//             document.querySelector('.breadcrumbTxt').innerText = breadcrumbTxt;
//             document.querySelector('.backButton').dataset.backto = 'home';
//             hideSortByMethods()
//             document.querySelector(".mobileReturnBtn").style.display = "block";
//             document.querySelector(".mobileReturnBtn .return-text").innerHTML = "Return";
//             document.querySelectorAll(".return-text").forEach(el => {
//               el.innerHTML = "Return";
//             })
//             document.querySelector(`#sort-by-state`).value = "";
//             document.querySelector(`#sort-by-state`).dispatchEvent(new Event('change', {
//               bubbles: true
//             }));
//             document.querySelectorAll(".searchPopUp .suggestionList li").forEach(el => {
//               el.style.display = "block";
//             })
//           }
//         });
        
//         document.querySelectorAll('.sortSect button').forEach(element => {
//           element.addEventListener('click', (e) => {
//             document.querySelector('.filterOption').classList.add('_hide');
//             document.querySelector('.search_breadcrumb').classList.add('_show');
//             document.querySelector('#find-your-school .find-your-school-list').classList.add('_hide');
//             document.querySelector('.mobileReturnBtn').classList.add('_show');
//             // document.querySelector('.backButton').dataset.backto = 'home';
//             let id = e.target.dataset.id;
//             currentSortId = id;
//             updateBreadcrumb('home', id == 'sort-by-state' ? 'Shop by State' : 'Shop by Conference');
//             showUpdateSortList(id);
//             document.querySelector(".mobileReturnBtn").style.display = "block";
//           });
//         });
        
//         document.querySelector('button.mobileReturnBtn').addEventListener('click', (e) => {
//           document.querySelector('.search_breadcrumb .backButton').click();
//         });
//         document.body.addEventListener('click', (e) => {
//           if (e.target.closest('.searchPopUp') && !e.target.closest('.input_area')) {
//             hideSearchPopup();
//           }
//         })
//         function sortItems(method) {
//           const itemsContainer = document.querySelector("#school-list");
//           const items = Array.from(itemsContainer.querySelectorAll("li"));
          
//           switch (method) {
//             case 'popular':
//               items.sort((a, b) => {
//                 const aSequence = parseInt(a.getAttribute("data-option-sequence"), 10);
//                 const bSequence = parseInt(b.getAttribute("data-option-sequence"), 10);
//                 return aSequence - bSequence;
//               });
//               break;
          
//             case 'a-z':
//               items.sort((a, b) => {
//                 const aValue = a.getAttribute("data-sorting_value").toLowerCase();
//                 const bValue = b.getAttribute("data-sorting_value").toLowerCase();
//                 return aValue.localeCompare(bValue);
//               });
//               break;
          
//             case 'z-a':
//               items.sort((a, b) => {
//                 const aValue = a.getAttribute("data-sorting_value").toLowerCase();
//                 const bValue = b.getAttribute("data-sorting_value").toLowerCase();
//                 return bValue.localeCompare(aValue);
//               });
//               break;
          
//             case 'newly-added':
//               items.sort((a, b) => {
//                 const aSequence = parseInt(a.getAttribute("data-option-sequence"), 10);
//                 const bSequence = parseInt(b.getAttribute("data-option-sequence"), 10);
//                 return bSequence - aSequence;
//               });
//               break;
          
//             default:
//               console.error('Unknown sorting method:', method);
//               return;
//           }
//           itemsContainer.innerHTML = '';
//           items.forEach(item => {
//             itemsContainer.appendChild(item);
//           });
//         }
  
//         function imageUrlToSvg(imgURl){
//           if(imgURl != ""){
//             const svgUrl = imgURl;
//             fetch(svgUrl)
//               .then(response => {
//                 if (!response.ok) {
//                   throw new Error('Network response was not ok ' + response.statusText);
//                 }
//                 return response.text();
//               })
//               .then(svgContent => {
//                 // Create a div to hold the SVG
//                 const div = document.createElement('div');
//                 div.innerHTML = svgContent;
//                 document.querySelector(".school-list-wrapper .breadcrumbTxt").innerHTML = svgContent+ document.querySelector(".school-list-wrapper .breadcrumbTxt").innerHTML;
//                 window.currentStateImage = "";
//               })
//               .catch(error => {
//                 console.error('There was a problem with the fetch operation:', error);
//               });
//             }
//           }
        
//         document.querySelectorAll(".sort_by").forEach(sortButton => {
//         sortButton.addEventListener("click", function (e) {
//           e.currentTarget.parentNode.querySelectorAll(".sort_by").forEach(el => {
//             el.classList.remove("active");
//           })
//           e.currentTarget.classList.add("active");
//           const method = sortButton.dataset.sort_by;
//           sortItems(method);
//           document.querySelector(".sorting-techniques").classList.toggle("open");
//         });
//         });
//       }
//     };
//     (function findYourschool() {
//       if (document.querySelector('main#MainContent > div') && document.querySelector('.sort_options')) {
//         initFindschool.init();
//       } else if (document.readyState !== 'complete') {
//         console.log("poling..")
//         setTimeout(findYourschool, 25);
//       }
//     })();
//   }
//   else{
//     for (let i = 1; i < rows.length; i++) {
//       const cells = rows[i];
//       window.collectionLogos[cells[4].split("?")[0].split("/")[cells[4].split("?")[0].split("/").length - 1]] = cells[5];
//     }
//   }
// }).catch(error => {
//   console.error('Error fetching data:', error);
// });